<template>
  <div class="flex flex-wrap paddig-responsive">
    <div class="flex w-full text-left center-responsive">
      <h2>{{ $t("played_soccer_or_futsal_question") }}</h2>
    </div>
    <div class="flex w-full mt-8">
      <div class="flex flex-col">
        <template v-for="option in options" :key="option.id">
          <label class="flex items-center mb-2">
            <input type="radio" :value="option.value" v-model="played" @change="showValue()" class="mr-2">
            <span>{{ option.label }}</span>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SelectOption } from "@/custom-models/levelingSelector";
import { Sport } from "@/enum/constants";
  
export default defineComponent({
  name: 'PlayedSoccerSelector',
  props: {
    propPlayed:{ 
      type: Number,
      default: 0.0 
    }
  },
  created (){
    this.played = this.propPlayed;
  },
  data() {
    return {
      Sport:Sport,
      played: 0,
      options: [
        { id: 1, label: this.$t("no_never"), value: 0.0 },
        { id: 2, label: this.$t("less_than_2_years"), value: 0.1 },
        { id: 3, label: this.$t("yes_more_than_2_years"), value: 0.2 },
        { id: 4, label: this.$t("yes_more_than_5_years"), value: 0.3 },
      ] as SelectOption[]
    };
  },
  methods: {
    showValue() {
      this.$emit("selectedPlayed", this.played);
    }
  }
});
</script>